// Constants
export const info_orden = () => {
  return {
    info_orden: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        name: 'pacId',
        readonly: true,
        type: 'number',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        datatype: {
          predeterminate: ''
        }
      },
      id_datos_pacientes: {
        type: 'text',
        label: 'Paciente',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        readonly: true,
        description: 'paciente',
        validate: '',
        datatype: { 
          disabled: true,
          type: 'select', 
          predeterminate: '',
          list: 'datos_pacientes',
          label: 'name'
        }
      },
      id_datos_proveedores_lente: {
        type: 'text',
        label: 'Proveedor lente',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        readonly: true,
        description: 'examen',
        validate: '',
        datatype: { 
          type: 'select', 
          predeterminate: '1',
          list: 'datos_proveedores_lente',
          label: 'name'
        }
      },
      id_datos_proveedores_montura: {
        type: 'text',
        label: 'Proveedor montura',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes','orden_pendientes'],
        readonly: true,
        description: 'examen',
        validate: '',
        datatype: { 
          type: 'select', 
          predeterminate: '1',
          list: 'datos_proveedores_montura',
          label: 'name'
        }
      },
      id_info_examens: {
        type: 'text',
        label: 'info examen',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        readonly: true,
        description: 'examen',
        validate: '',
        datatype: 
        {
          predeterminate: '',
        }
      },
      fecha: {
        type: 'text',
        label: 'Fecha',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'fecha',
        validate: 'required',
        datatype: 
        {
          type: 'date',
          disabled: false,
          predeterminate: '',
        }
      },
      estado: {
        type: 'number',
        label: 'Estado',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes','orden_pendientes','paciente_pacientes'],
        placeholder: '',
        description: 'numero_factura',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: 'producción',
        }
      },
      consecutivo: {
        type: 'number',
        label: 'Registro orden',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'numero_factura',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: '',
          prepend: '',
          append: '',
        }
      },
      montura: {
        type: 'text',
        label: 'Montura',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'montura',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },    
      color: {
        type: 'text',
        label: 'color',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'Color lente',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      filtro: {
        type: 'text',
        label: 'Filtro',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes'],
        placeholder: '',
        description: 'filtro del lente',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      fecha_recibido: {
        type: 'text',
        label: 'Fecha de recibido el pedido',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes','orden_pendientes'],
        placeholder: '',
        description: 'fecha de recibido',
        validate: 'required',
        datatype: 
        {
          type: 'date',
          disabled: false,
          predeterminate: '',
        }
      },
      fecha_entrega: {
        type: 'text',
        label: 'Dia De Entrega',
        dataform: ['orden_registro','orden_antiguos','orden_pendientes','orden_pendientes'],
        placeholder: '',
        description: 'dia de entrega',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },     
    }
  }
}

export function asign_info_orden(){
  var asign= Object.keys(info_orden().info_orden);
  var objeto = info_orden().info_orden
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

